import { DateTime } from 'luxon'
import React from 'react'
import { useSelector } from 'react-redux'

function ListaYear() {
    const dataYear = useSelector((user) => user.dataYear.data);
    const spesaAvg = useSelector((user) => user.dataYear.spesaAvgMese);
    const spesaAvgMin = spesaAvg - (spesaAvg * 5) / 100;
    const spesaAvgMax = spesaAvg + (spesaAvg * 5) / 100;  
    return (
        <table className="year">
          <thead>
            <tr className="headerTable">
              <th className="date">Mese</th>
              <th className="priceKwh">
        
                <span>Prezzo</span>
              </th>
              <th className="kwh">
                <span>kWh</span>
              </th>
              <th className="euro">
                <span>Euro</span>
              </th>
              <th className="badge">
                    <span></span>
              </th>
            </tr>
          </thead>
          <tbody>
          {dataYear !== null ? (
              dataYear.map((d, i) => 
              d.spesa_giorno === 0 ? null : (
                  <tr key={i}>
                      <td className="date">
                          {DateTime.fromISO(d.data_competenza, {locale: 'it'}).toFormat(`MMMM`)}
                      </td>
                      <td className="priceKwh">
                        {(d.entry_amount / d.entry_kwh).toFixed(2).replace(/\./g, ",")}
                      </td>
                      {d.kwh_tot === 0 ? (
                          <td className="kwh noData">Nessun dato</td>
                      ) : (
                          <td className="kwh">
                              {parseFloat(d.entry_kwh).toFixed(0).replace(/\./g, ",")}{" "}
                          </td>
                      )}
                    <td className="euro">
                    {d.spesa_giorno === null
                        ? "n.d."
                        : parseFloat(d.entry_amount)
                            .toFixed(2)
                            .replace(/\./g, ",")}{" "}
                    </td>
                    <td className="badge">
                      <span style={d.entry_amount > spesaAvgMax ? {backgroundColor: '#FF5668'} : d.entry_amount >= spesaAvgMin ? {backgroundColor: '#F6BD16'} : d.entry_amount < spesaAvgMin ? {backgroundColor: '#5AD8A6'} : null}></span>
                    </td>
                  </tr>
              )).reverse()
          ) : null} 
          </tbody>
        </table>
    );
}

export default ListaYear
